import { useState, Suspense, useCallback, useRef, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AgGridColumn, AgGridReact } from "ag-grid-react";

// import { Pagination } from "@material-ui/lab";
import { CustomPagination } from "../../../shared";
import { Button } from "@material-ui/core";
import { CellValueChangedEvent, ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";

import { UIContext } from "../../../../contexts";
import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
import { api } from "../../../../utils/api";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import getAgGridHeight from "../../../../utils/commonFunctions/getAgGridHeight";
import { DataIntegrityReportType } from "../../../../@types/reportType.types";
import { useEmployerRoute } from "../../../../hooks";
import useRouteParam from "../../../../hooks/useRouteParam";
import ExtractRouteParams from "../../../../utils/commonFunctions/extractRouteParams";
import { LINK } from "../../../../config/config";
import axios from "axios";
import { dateTimeZoneConverter } from "../../../../utils/commonFunctions/date";

const DataIntegrityReportManagement = ({ dataReports }: any): JSX.Element => {
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const agGridRef = useRef<any>(null);
	const [isRowSelected, setIsRowSelected] = useState(false);
	const navigate = useNavigate();
	const isEmployerRoute = useEmployerRoute();
	const queryGroupNumber = useRouteParam("gn");
	const routeParam = ExtractRouteParams(); // This is to extract the route after ?(Question Mark)
	const { setDashboardHeader } = useContext(UIContext);
	const [gridHeight, setGridHeight] = useState("300px");
	// const [reportData, setReportData] = useState<DataIntegrityReportType[]>([
	// 	{
	// 		report_type: "VEB Empty Benefit Amount Report",
	// 		description:
	// 			"This report will pull all the empty benefit amount details of the employees of critical illness/whole life plan.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "VEB Empty Rider Benefit Amount Report",
	// 		description:
	// 			"This report will pull all the empty rider benefit amount details of the employees of accident plan.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "VEB Invalid Sub Plan Report",
	// 		description: "This report will pull all the invalid sub plan of all VEB Enrollments of the listed plans.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Invalid Member SSN From VEB Enrollment Report",
	// 		description:
	// 			"This report will pull all the Members for whom enrollment is created but member is not present.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Invalid State For Member Report",
	// 		description: "This report will pull all the invalid or null state for the members.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Invalid ZIP For Member Report",
	// 		description: "This report will pull all the invalid ZIP which contains hypen(-) for the members.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Not Exist Member Location Report",
	// 		description:
	// 			"This report will pull all the location details which exists in member model and but not in locations.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Active Group Plan Null Effective Date Report",
	// 		description: "This report will pull all the Active Group Plan(s) with effective date as null.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Active Paycheck Less Than One Report",
	// 		description: "This report will pull all the Active Paycheck whose value will less than one.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Dependent More Than Equal To 26 Years Report",
	// 		description: "This report will pull all the dependents with 26 Years and is enrolled in any group plan.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	}
	// ]);

	// const getReports = useCallback(async () => {
	// 	const JWT_LOC = localStorage.getItem("@jwt");
	// 	const GET_API = `${LINK}/reports/report-log?group_number=220`;

	// 	const response = await axios.get(GET_API, {
	// 		headers: {
	// 			Authorization: `Bearer ${JWT_LOC}`
	// 		}
	// 	});

	// 	const responseData = response.data.result;
	// 	// console.log("response --> ", responseData);

	// 	reportData.forEach((data: any) => {
	// 		responseData.forEach((res_data: any) => {
	// 			// datas which are present in both the response and constants
	// 			if (data.report_type === res_data.name) {
	// 				data.last_generated_by =
	// 					res_data.last_generated_first_name + " " + res_data.last_generated_last_name;
	// 				data.last_generated_on = res_data.last_date;
	// 				setReportData(Object.assign([], reportData, { ...data }));
	// 			}
	// 		});
	// 	});
	// }, []);

	const handleAgGridReady = (params: GridReadyEvent) => {
		// eslint-disable-next-line no-unused-vars
		const { api, columnApi } = params;
		setAgGridAPI(api);
		setAgGridColumnAPI(columnApi);
		const columnIds: any[] = [];
		columnApi?.getAllColumns()?.forEach((column: any) => {
			columnIds.push(column.colId);
		});
		columnApi.autoSizeColumns(columnIds);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
	};

	const handleGenerateReportClick = useCallback(
		({
			_isEmployerRoute,
			_queryGroupNumber
		}: {
			_isEmployerRoute: boolean | null;
			_queryGroupNumber: number | null;
		}) => {
			if (agGridRef?.current) {
				const focusedCell = agGridRef.current.api.getFocusedCell();
				const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
				const {
					data: { report_route }
				} = row;

				let pathname;

				// if (report_type === "VEB Empty Benefit Amount Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/data-integrity-report/empty-benefit-amount?${routeParam}`)
				// 		: (pathname = "/data-integrity-report/empty-benefit-amount");
				// } else if (report_type === "VEB Empty Rider Benefit Amount Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/data-integrity-report/empty-rider-benefit-amount?${routeParam}`)
				// 		: (pathname = "/data-integrity-report/empty-rider-benefit-amount");
				// } else if (report_type === "VEB Invalid Sub Plan Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/data-integrity-report/invalid-sub-plan?${routeParam}`)
				// 		: (pathname = "/data-integrity-report/invalid-sub-plan");
				// } else if (report_type === "Invalid Member SSN From VEB Enrollment Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/data-integrity-report/invalid-member-ssn-from-veb-enrollment?${routeParam}`)
				// 		: (pathname = "/data-integrity-report/invalid-member-ssn-from-veb-enrollment");
				// } else if (report_type === "Invalid State For Member Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/data-integrity-report/invalid-state-for-member?${routeParam}`)
				// 		: (pathname = "/data-integrity-report/invalid-state-for-member");
				// } else if (report_type === "Invalid ZIP For Member Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/data-integrity-report/invalid-zip-for-member?${routeParam}`)
				// 		: (pathname = "/data-integrity-report/invalid-zip-for-member");
				// } else if (report_type === "Not Exist Member Location") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/data-integrity-report/not-exist-member-location?${routeParam}`)
				// 		: (pathname = "/data-integrity-report/not-exist-member-location");
				// } else if (report_type === "Active Group Plan Null Effective Date Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/data-integrity-report/active-group-plan-null-effective-date?${routeParam}`)
				// 		: (pathname = "/data-integrity-report/active-group-plan-null-effective-date");
				// } else if (report_type === "Active Paycheck Less Than One Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/data-integrity-report/active-paycheck-less-than-one?${routeParam}`)
				// 		: (pathname = "/data-integrity-report/active-paycheck-less-than-one");
				// } else if (report_type === "Dependent More Than Equal To 26 Years Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/data-integrity-report/dependent-more-than-26-years?${routeParam}`)
				// 		: (pathname = "/data-integrity-report/dependent-more-than-26-years");
				// }

				if (_isEmployerRoute === true && _queryGroupNumber !== null) {
					pathname = `/employer${report_route}?${routeParam}`;
				} else {
					pathname = `${report_route}`;
				}

				navigate(pathname as string);
			}
		},
		[navigate, routeParam]
	);

	const handleActionButtonRender = ({
		_isEmployerRoute,
		_queryGroupNumber
	}: {
		_isEmployerRoute: boolean | null;
		_queryGroupNumber: number | null;
	}) => {
		return (
			<Button
				className="ag-grid-cell-button"
				variant="outlined"
				onClick={() =>
					handleGenerateReportClick({
						_isEmployerRoute,
						_queryGroupNumber
					})
				}
			>
				Generate Report
			</Button>
		);
	};

	const handleSelectionChanged = useCallback(() => {
		const selectedRow = agGridAPI?.getSelectedRows()[0];
		if (selectedRow) {
			setIsRowSelected(true);
		} else {
			setIsRowSelected(false);
		}
	}, [agGridAPI]);

	const handleCellValueRender = ({ value }: { value: string }) => {
		return <div>{value ? <div>{value}</div> : <div style={{ marginLeft: 15 }}>N/A</div>}</div>;
	};

	const handleDateCellRenderer = ({ value }: { value: any }) => {
		const date = dateTimeZoneConverter(value as string) as string;
		return <div>{value ? date : "N/A"}</div>;
	};

	useEffect(() => {
		// console.log("reports state => ", reportData);

		setDashboardHeader(ADMIN_DASHBOARD_HEADER.data_integrity_report_management);
	}, [setDashboardHeader]);

	useEffect(() => {
		const _gridHeight = getAgGridHeight(dataReports.length);
		setGridHeight(_gridHeight);
	}, [dataReports.length]);

	return (
		<div className="group-home-page">
			<div className="group-home-pg-grid-container">
				<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
					<AgGridReact
						ref={agGridRef}
						// rowData={reportData}
						rowData={dataReports}
						onGridReady={handleAgGridReady}
						onFirstDataRendered={handleFirstDataRendered}
						rowSelection={"Single"}
						animateRows
						defaultColDef={{
							filter: "agTextColumnFilter",
							floatingFilter: true,
							resizable: true
						}}
						onSelectionChanged={handleSelectionChanged}
						frameworkComponents={{
							handleActionButtonRender: handleActionButtonRender,
							handleCellValueRender: handleCellValueRender,
							handleDateCellRenderer: handleDateCellRenderer
						}}
						onCellValueChanged={(params: CellValueChangedEvent) => {
							params.api.refreshCells({
								force: true,
								columns: ["branding"]
							});
						}}
						enableCellChangeFlash={true}
					>
						<AgGridColumn
							field="report_name"
							headerName="Report Name"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							// cellRenderer="handleCellValueRender"
						></AgGridColumn>
						<AgGridColumn
							field="report_description"
							headerName="Description"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							// cellRenderer="handleCellValueRender"
						></AgGridColumn>
						<AgGridColumn
							field="report_logs.last_generated_by"
							headerName="Last Generated by"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							// cellRenderer="handleCellValueRender"
						></AgGridColumn>
						<AgGridColumn
							field="report_logs.last_generated_on"
							headerName="Last Generated On"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleDateCellRenderer"
						></AgGridColumn>
						<AgGridColumn
							field="action"
							headerName="Action"
							cellRenderer="handleActionButtonRender"
							cellRendererParams={{
								_isEmployerRoute: isEmployerRoute,
								_queryGroupNumber: queryGroupNumber
							}}
							filter={false}
						></AgGridColumn>
					</AgGridReact>
				</div>
			</div>
		</div>
	);
};

export default DataIntegrityReportManagement;
